import { useState, useEffect } from "react";
import PropType from "prop-types";
import CreditzContainer from "../creditzList";

const SentCreditz = ({ setView, setValues, creditz = [], updateNotification }) => {

  return (
    <CreditzContainer
      pending={creditz.filter((c) => c.notification.status === 0)}
      accepted={creditz.filter((c) => c.notification.status === 1)}
      setView={setView}
      setValues={setValues}
      updateNotification={updateNotification}
    />
  );
};

SentCreditz.propTypes = {
  creditz: PropType.array,
  setView: PropType.func,
  setValues: PropType.func,
  updateNotification: PropType.func,
};

export default SentCreditz;
